import { ReactElement } from 'react';
import { Grid, Stack } from '@mui/material';
import { LabelledText } from 'components/LabelledText/LabelledText';
import { MoreDropdown, DropdownOption } from 'components/Menu/MoreDropdown';
import { Panel } from 'components/Panel/Panel';
import { useTranslation } from 'react-i18next';
import { BaseAudit, Fasteners } from 'types/domainTypes';
import PullOverDesignResistance from '../../assets/images/PullOverDesignResistance.svg';
import PullOutDesignResistance from '../../assets/images/PullOutDesignResistance.svg';
interface FastenersViewProps {
  fasteners?: Fasteners & BaseAudit;
  onEditClick: () => void;
  onDeleteClick: () => void;
  fromManufacturerSpecs?: boolean;
}

export function FastenersView({ fasteners, onEditClick, onDeleteClick }: FastenersViewProps): ReactElement | null {
  const { t } = useTranslation();

  if (!fasteners) {
    return null;
  }

  const displayExtraFields = !!fasteners.fastenerName && !!fasteners.manufacturerName;
  const moreButton = (
    <MoreDropdown data-testid="fastener-details-dropdown">
      <DropdownOption callback={onEditClick} label={t('calculation-page.label-edit-fasteners')} />
      <DropdownOption callback={onDeleteClick} label={t('calculation-page.label-remove-fasteners')} />
    </MoreDropdown>
  );

  return (
    <Panel
      data-testid="fasteners-panel"
      panelTitle={t('calculation-page.label-calculation-fasteners')}
      panelSummary={t('common.summary-format', {
        createdBy: fasteners.createdByName ? fasteners.createdByName : fasteners.createdBy,
        modifiedOn: fasteners.modifiedOn,
        modifiedBy: fasteners.modifiedByName ? fasteners.modifiedByName : fasteners.modifiedBy,
      })}
      panelButton={moreButton}
    >
      <Grid item xs={4}>
        <Stack spacing={2}>
          {displayExtraFields ? (
            <LabelledText label="calculation-page.label-fastener-manufacturer" value={fasteners.manufacturerName} />
          ) : null}
          <LabelledText
            label="calculation-page.fasteners-details-dialog.label-pull-out-design-resistance"
            value={`${fasteners.pullOutDesignResistance} kN`}
            labelIcon={
              <img
                data-testid="pull-out-icon"
                src={PullOutDesignResistance}
                alt={t('calculation-page.fasteners-details-dialog.label-pull-over-design-resistance')}
                style={{ width: '3rem', marginBottom: '0.15rem', marginLeft: '0.5rem' }}
              />
            }
          />
        </Stack>
      </Grid>
      <Grid item xs={4}>
        <Stack spacing={2}>
          {displayExtraFields ? <LabelledText label="calculation-page.label-fastener-name" value={fasteners.fastenerName} /> : null}
          <LabelledText
            label="calculation-page.fasteners-details-dialog.label-pull-over-design-resistance"
            value={`${fasteners.pullOverDesignResistance} kN`}
            labelIcon={
              <img
                data-testid="pull-over-icon"
                src={PullOverDesignResistance}
                alt={t('calculation-page.fasteners-details-dialog.label-pull-over-design-resistance')}
                style={{
                  width: '3rem',
                  paddingTop: '0',
                  marginBottom: '0.15rem',
                  marginLeft: '0.25rem',
                }}
              />
            }
          />
        </Stack>
      </Grid>
    </Panel>
  );
}
